module.exports = __webpack_public_path__ + "static/img/landReach.316f8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landReach.jpg
// module id = bKA3
// module chunks = 1